// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___KJSIg","label":"label___cvaLw","text":"text___cfNnB","blue":"blue___rMRbH","pink":"pink___EfXpA","green":"green___sg6MU"};